import { render, staticRenderFns } from "./RsaConfigurazioneSpeseExtraListPage.vue?vue&type=template&id=ac821848"
import script from "./RsaConfigurazioneSpeseExtraListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneSpeseExtraListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports